import { routerStyxie } from '@/router/styxieBridge'

Styxie.Initializers.MobileCompanyCamProjects = routerStyxie({ actions: ['index', 'show']})
